<template>
  <span
    class="form-error is-visible margin-0 pega-pre-wrap"
    data-test="label"
    v-text="label"
  />
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: ''
    }
  }
}
</script>
